export default {
  token: null,
  showLoading: false,
}



// WEBPACK FOOTER //
// ./src/store/state.js